// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PasswordField_container__rVCfR {
  display: flex;
  flex-direction: column;
  margin-top: 18px;
}

.PasswordField_input__EJRLY {
  height: 40px;
  border: solid 1px #666666;
  border-radius: 4px;
  margin-top: 8px;
  padding: 9px 16px;
}

input[type=password]::-ms-reveal,
input[type=password]::-ms-clear {
  display: none;
}

.PasswordField_error-text__DcG\\+8 {
  margin-top: 10px;
  color: #c9423c;
  font-size: 12px;
}

.PasswordField_input-error__ubah\\+ {
  border: solid 1px #c9423c;
}

.PasswordField_input-error__ubah\\+:focus-within {
  outline: none !important;
  border: solid 2px #c9423c;
}

.PasswordField_input-error__ubah\\+:focus-within {
  outline: none !important;
  border: solid 2px #c9423c;
}

.PasswordField_visibility__yKdRX {
  margin-top: -33px;
  z-index: 2;
  align-self: flex-end;
  margin-right: 1%;
}
.PasswordField_visibility__yKdRX Button {
  color: #666666;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/Form/PasswordField/PasswordField.module.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAFJ;;AAKA;;EAEI,aAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,cCHI;EDIJ,eEzBK;AFuBT;;AAKA;EACI,yBAAA;AAFJ;;AAKA;EACI,wBAAA;EACA,yBAAA;AAFJ;;AAKA;EACI,wBAAA;EACA,yBAAA;AAFJ;;AAKA;EACI,iBAAA;EACA,UAAA;EACA,oBAAA;EACA,gBAAA;AAFJ;AAGI;EACI,cAAA;EACA,eEjDC;AFgDT","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.container {\n    display: flex;\n    flex-direction: column;\n    margin-top: 18px;\n}\n\n.input {\n    height: 40px;\n    border: solid 1px #666666;\n    border-radius: 4px;\n    margin-top: 8px;\n    padding: 9px 16px;\n}\n\ninput[type=password]::-ms-reveal,\ninput[type=password]::-ms-clear {\n    display: none;\n}\n\n.error-text {\n    margin-top: 10px;\n    color: colors.$error;\n    font-size: typography.$body-s;\n}\n\n.input-error {\n    border: solid 1px colors.$error;\n}\n\n.input-error:focus-within {\n    outline: none !important;\n    border: solid 2px colors.$error;\n}\n\n.input-error:focus-within {\n    outline: none !important;\n    border: solid 2px colors.$error;\n}\n\n.visibility {\n    margin-top: -33px;\n    z-index: 2;\n    align-self: flex-end;\n    margin-right: 1%;\n    Button {\n        color: #666666;\n        font-size: typography.$body-s;\n    }\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PasswordField_container__rVCfR`,
	"input": `PasswordField_input__EJRLY`,
	"error-text": `PasswordField_error-text__DcG+8`,
	"input-error": `PasswordField_input-error__ubah+`,
	"visibility": `PasswordField_visibility__yKdRX`
};
export default ___CSS_LOADER_EXPORT___;
